import { render, staticRenderFns } from "./subpage-title.vue?vue&type=template&id=15a8c74f&scoped=true"
import script from "./subpage-title.vue?vue&type=script&lang=js"
export * from "./subpage-title.vue?vue&type=script&lang=js"
import style0 from "./subpage-title.vue?vue&type=style&index=0&id=15a8c74f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a8c74f",
  null
  
)

export default component.exports